/**
 * RendererProperties.ts
 */
export class RendererProperties {
    constructor(device, viewport) {
        this.device = device;
        this.viewport = viewport;
        this.autoResize = true;
        this.transparent = true;
        this.antialias = false;
        this.restrictScale = false;
        this.targetFrameRate = 30;
        this.minFrameRate = 15;
        this.resolution = 1;
        this.backgroundColor = 0xFFFFFF;
        this.view = null;
        this.preserveDrawingBuffer = false;
        this.clearBeforeRender = true;
        this.preventTouchMove = true;
        this.showFrameRate = false;
        this.legacy = false;
    }
    getJsonProperties() {
        return {
            width: this.viewport.width,
            height: this.viewport.height,
            backgroundColor: this.backgroundColor,
            view: this.view,
            transparent: this.transparent,
            preserveDrawingBuffer: this.preserveDrawingBuffer,
            clearBeforeRender: this.clearBeforeRender,
            resolution: this.resolution,
            antialias: this.antialias,
            autoDensity: true
        };
    }
}
//# sourceMappingURL=RendererProperties.js.map